const mutations = {
  onGet(state, payload) {
    payload.event.context.subscriptions = payload.response.data.data.data
    if (payload.event.context.options) {
      payload.event.context.options.itemsPerPage = parseInt(payload.response.data.data.per_page)
      payload.event.context.options.page = payload.response.data.data.current_page
      payload.event.context.options.total = payload.response.data.data.total
      payload.event.context.loadTable = false
    }
  },
  onGetPlans(state, payload) {
    payload.event.context.plans = payload.response.data.data
  },
  onPost (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.loading = false
    payload.event.context.redirect()
  },
  onPut (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.loading = false
    payload.event.context.redirect()
  },
  onGetById(state, payload) {
    payload.event.context.editedItem = payload.response.data.data
    payload.event.context.loadItem = false
  },
  onDelete (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.loading = false
    payload.event.context.close()
    payload.event.context.get(payload.event.context.options.page, payload.event.context.options.itemsPerPage)
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
  }
}

export default mutations